const FEATURE_HELP_URLS = {
  agent_bots: 'https://www.ega.go.tz/',
  agents: 'https://www.ega.go.tz/',
  audit_logs: 'https://www.ega.go.tz/',
  campaigns: 'https://www.ega.go.tz/',
  canned_responses: 'https://www.ega.go.tz/',
  channel_email: 'https://www.ega.go.tz/',
  channel_facebook: 'https://www.ega.go.tz/',
  custom_attributes: 'https://www.ega.go.tz/',
  dashboard_apps: 'https://www.ega.go.tz/',
  help_center: 'https://www.ega.go.tz/',
  inboxes: 'https://www.ega.go.tz/',
  integrations: 'https://www.ega.go.tz/',
  labels: 'https://www.ega.go.tz/',
  macros: 'https://www.ega.go.tz/',
  message_reply_to: 'https://www.ega.go.tz/',
  reports: 'https://www.ega.go.tz/',
  sla: 'https://www.ega.go.tz/',
  team_management: 'https://www.ega.go.tz/',
  webhook: 'https://www.ega.go.tz/',
  billing: 'https://www.ega.go.tz/',
  saml: 'https://www.ega.go.tz/',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
